module.exports = __webpack_public_path__ + "static/vliegtickets-logo-nl-b101721d12d0bbc3c93cd2661d3d27d6.svg";